import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  min-height: calc(2.5em + 5px);
  min-width: 0;
  overflow: hidden;
  /* Let users highlight/copy the cell text — an <a> drag-hijacks selection otherwise. */
  -webkit-user-drag: none;

  &:hover {
    color: inherit;
  }
`;

const Content = styled.span`
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: text;
`;

// `draggable={false}` stops the browser from starting a link-drag when the user
// click-drags to select cell text (e.g. a phone number) to copy it.
const LinkableCell = React.forwardRef(({ children, onClick, ...props }, ref) => {
  const handleClick = (event) => {
    // A drag that left a text selection ends in a click — don't navigate, so the user
    // keeps their selection to copy. A plain click (no selection) navigates as before.
    const selection =
      typeof window !== "undefined" && typeof window.getSelection === "function" ? window.getSelection() : null;
    if (selection && selection.toString().length > 0) {
      event.preventDefault();
      return;
    }
    if (typeof onClick === "function") onClick(event);
  };

  return (
    <StyledLink draggable={false} {...props} onClick={handleClick} ref={ref}>
      <Content>{children}</Content>
    </StyledLink>
  );
});

LinkableCell.displayName = "LinkableCell";

LinkableCell.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
};

export default LinkableCell;
